/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Check_In_OutInputs */

const en_field_check_in_out = /** @type {(inputs: Field_Check_In_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in/out Policy`)
};

const es_field_check_in_out = /** @type {(inputs: Field_Check_In_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de Check-in/out`)
};

const fr_field_check_in_out = /** @type {(inputs: Field_Check_In_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique d'arrivée/départ`)
};

const de_field_check_in_out = /** @type {(inputs: Field_Check_In_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in/out-Richtlinien`)
};

const ja_field_check_in_out = /** @type {(inputs: Field_Check_In_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チェックイン/アウトの規定`)
};

const zh_field_check_in_out = /** @type {(inputs: Field_Check_In_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入住/退房政策`)
};

const ar_field_check_in_out = /** @type {(inputs: Field_Check_In_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سياسة تسجيل الدخول/الخروج`)
};

const id_field_check_in_out = /** @type {(inputs: Field_Check_In_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebijakan Check-in/out`)
};

const it_field_check_in_out = /** @type {(inputs: Field_Check_In_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politiche di Check-in/out`)
};

const ru_field_check_in_out = /** @type {(inputs: Field_Check_In_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Правила заезда/выезда`)
};

const pt_field_check_in_out = /** @type {(inputs: Field_Check_In_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de Check-in/out`)
};

const ko_field_check_in_out = /** @type {(inputs: Field_Check_In_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`체크인/체크아웃 정책`)
};

/**
* | output |
* | --- |
* | "Check-in/out Policy" |
*
* @param {Field_Check_In_OutInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_check_in_out = /** @type {((inputs?: Field_Check_In_OutInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Check_In_OutInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_check_in_out(inputs)
	if (locale === "es") return es_field_check_in_out(inputs)
	if (locale === "fr") return fr_field_check_in_out(inputs)
	if (locale === "de") return de_field_check_in_out(inputs)
	if (locale === "ja") return ja_field_check_in_out(inputs)
	if (locale === "zh") return zh_field_check_in_out(inputs)
	if (locale === "ar") return ar_field_check_in_out(inputs)
	if (locale === "id") return id_field_check_in_out(inputs)
	if (locale === "it") return it_field_check_in_out(inputs)
	if (locale === "ru") return ru_field_check_in_out(inputs)
	if (locale === "pt") return pt_field_check_in_out(inputs)
	return ko_field_check_in_out(inputs)
});